(function() {
  'use strict';

  function Cards(Sidebar) {
    var service = {};

    service.register = function() {
      var cards = [
        {
          id: 'columns-mapping-info',
          title: 'Column Matching',
          directive: 'columns-mapping-info-card',
          options: {
            routes: ['epf.bulk-actions.new', 'epf.bulk-actions.edit']
          }
        },
        {
          id: 'results-overview',
          title: 'Results overview',
          directive: 'results-overview-card',
          options: {
            routes: ['epf.bulk-actions.view']
          }
        },
        {
          id: 'options-used',
          title: 'Options',
          directive: 'options-used-card',
          options: {
            routes: ['epf.bulk-actions.view']
          }
        }
      ];

      Sidebar.registerCards(cards);
    };

    return service;
  }

  Cards.$inject = ['SidebarService'];

  angular.module('component.bulkActions')
    .service('BulkActionCards', Cards);
})();
